import React from 'react'
import { string } from 'prop-types'

const TransactionNotCompleted = ({ language }) => {
  if (language === 'fr')
    return (
      <>
        <h4>La transaction n'a pas été complétée</h4>
        <p>
          Pour des raisons hors du contrôle de Bay Ferries Limited et
          Northumberland Ferries Limited, votre paiement a été refusé. Si vous
          éprouvez des difficultés à compléter votre transaction, veuillez
          communiquer avec votre institution financière ou vous pouvez effectuer
          votre réservation par téléphone en communiquant avec notre service à
          la clientèle au 1-877-762-7245.
        </p>
        <p>Que voulez-vous faire?</p>
      </>
    )

  return (
    <>
      <h4>The transaction has not been completed</h4>
      <p>
        For reasons beyond the control of Bay Ferries Limited and Northumberland
        Ferries Limited, your payment has been refused. If you are having
        difficulty completing your transaction, please contact your financial
        institution or you can make your reservation by phone by contacting our
        customer service at 1-877-762-7245.
      </p>
      <p>What do you want to do?</p>
    </>
  )
}

TransactionNotCompleted.propTypes = {
  language: string.isRequired
}

export default TransactionNotCompleted
